import { render, staticRenderFns } from "./automatic-course-scheduling.vue?vue&type=template&id=8a4b2544&scoped=true"
import script from "./automatic-course-scheduling.vue?vue&type=script&lang=js"
export * from "./automatic-course-scheduling.vue?vue&type=script&lang=js"
import style0 from "./automatic-course-scheduling.vue?vue&type=style&index=0&id=8a4b2544&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4b2544",
  null
  
)

export default component.exports